import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'

export const selectUploadEvent = (state: RootState): Event => state.uploadReducer.uploadEvent

export const selectUploadFile = (state: RootState): string => state.uploadReducer.uploadFile
